import {makeKey,update} from '../../../../utils/reducerOperations';
export function getOrganizationProfileStarted(state, payload) {
    return makeKey(
        'getOrganizationProfileApi',
        update(state.getOrganizationProfileApi, {
            isProcessing: true,
            isDataFetched:false
        })
    );
}